import { HomeService } from "./../../../services/home/home.service";
import { Component, OnInit } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-mobile-page",
  templateUrl: "./mobile-page.component.html",
  styleUrls: ["./mobile-page.component.css"],
})
export class MobilePageComponent implements OnInit {
  title: string;
  facts;

  isLoading = true;
  isData = false;
  isCustom = true;
  data;
  slides;
  works;
  constructor(
    private service: HomeService,
    private titleService: Title,
    private metaService: Meta,
    private translateService: TranslateService
  ) {
    this.title = this.translateService.instant(
      "Programming mobile applications Android and iPhone"
    );
  }

  ngOnInit(): void {
    this.metaService.addTag({
      name: "description",
      content:
        "شركة كودس روتس هي شركة متخصصه في تصميم المواقع وتطبيقات الجوال نتميز بفضل الله باستخدام احدث اللغات والتقنيات في تصميم المواقع والتطبيقات",
    });
    this.metaService.addTag({
      name: "og:description",
      content:
        "شركة كودس روتس هي شركة متخصصه في تصميم المواقع وتطبيقات الجوال نتميز بفضل الله باستخدام احدث اللغات والتقنيات في تصميم المواقع والتطبيقات",
    });
    this.metaService.addTag({
      name: "twitter:description",
      content:
        "شركة كودس روتس هي شركة متخصصه في تصميم المواقع وتطبيقات الجوال نتميز بفضل الله باستخدام احدث اللغات والتقنيات في تصميم المواقع والتطبيقات",
    });
    this.metaService.addTag({
      name: "keywords",
      content:
        "برمجة تطبيقات الاندرويد ,برمجة تطبيقات الايفون,برمجة تطبيقات الجوالتصميم مواقع باحترافية,شركة تصميم مواقع في السعودية,تصميم مواقع,تصميم تطبيقات الجوال,افضل شركة لتصميم المواقع ,افضل شركة لبرمجه التطبيقات,تصميم تطبيقات اندرويد",
    });

    this.titleService.setTitle(this.title);
    this.getWorks();

    this.facts = [
      {
        icon: "./../../../assets/images/android.png",
        title: this.translateService.instant("android apps design"),
        content:
          this.translateService.instant("We can convert your idea to an application that works on the Android working environment, starting from planning, design and implementation, we guarantee an application that can compete in the Google Android Market application store"),
      },
      {
        icon: "./../../../assets/images/apple.png",
        title: this.translateService.instant("IOS application design"),
        content:
          this.translateService.instant("Do you have an application idea that you would like to implement on the IOS operating environment? codesroots can help develop your idea into an actual application that will help you to face your competitors strongly, we will make you at the top"),
      },
      {
        icon: "./../../../assets/images/game-controller.png",
        title: this.translateService.instant("Programming games and applications for profit"),
        content:
          this.translateService.instant("codesroots provides new profitable ideas in the field of profit from smart phone applications. You can contact us to determine and know the ideas we have available"),
      },
    ];
  }


  getWorks() {
    this.service.getWorks().subscribe((res) => {
      this.data = res;
      this.works = this.data.andorid;

      this.isLoading = false;
      this.isData = true;
    });
  }
}
